import { DocumentMetadataPropertyUiWidgetHintEnum } from 'shared/domains/apollo/generated/types';
import { AllowedValuesList } from './AllowedValuesList';
import { BooleanField } from './BooleanField';
import { DateField } from './DateField';
import { MultilineTextField } from './MultilineTextField';
import { NumberField } from './NumberField';
import { MultiSelectWithInput } from './SelectWithInput';
import { SimpleTextField } from './SimpleTextField';
import { UserField } from './UserField';
import { useMetadataField } from '../useMetadataField';
export function FormField() {
    const { property } = useMetadataField();
    const { name, uiWidgetHint, allowedValues } = property;
    switch (uiWidgetHint) {
        case DocumentMetadataPropertyUiWidgetHintEnum.Select: {
            if (allowedValues === null || allowedValues === void 0 ? void 0 : allowedValues.length) {
                return <AllowedValuesList />;
            }
            /**
             * NOTE: If its not a regular list of allowed values it is a reference field,
             * and we will assume it is a user reference if so. Document references are
             * handled one level up already.
             */
            return <UserField />;
        }
        case DocumentMetadataPropertyUiWidgetHintEnum.SelectWithInput:
            return <MultiSelectWithInput name={name}/>;
        case DocumentMetadataPropertyUiWidgetHintEnum.DatePicker:
        case DocumentMetadataPropertyUiWidgetHintEnum.DateTimePicker:
            return <DateField />;
        case DocumentMetadataPropertyUiWidgetHintEnum.InputNumber:
            return <NumberField />;
        case DocumentMetadataPropertyUiWidgetHintEnum.InputText:
            return <SimpleTextField />;
        case DocumentMetadataPropertyUiWidgetHintEnum.TextArea:
            return <MultilineTextField />;
        case DocumentMetadataPropertyUiWidgetHintEnum.Switch:
            return <BooleanField />;
        default: {
            const exhaustive = uiWidgetHint;
            return exhaustive;
        }
    }
}
